import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { DeleteFinanceAccountsRequestModel, DeleteFinanceAccountsResponseModel } from "@/features/accounts/finance/services/delete-accounts-model";

export class DeleteFinanceAccountsApi {
  /**
   * 銀行口座削除API
   */
  public deleteFinanceAccounts = async (
    param: DeleteFinanceAccountsRequestModel
  ): Promise<DeleteFinanceAccountsResponseModel> => {
    const path = `/api/financeaccounts/finances`;
    const res = await ApiClient.instance.delete<DeleteFinanceAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
